(function() {

    angular
    .module('meanApp')
    .factory('titleFactory', ['$rootScope',
    function ($rootScope) {
        //default title
        
        console.log('the title set is ',$rootScope.title )
        return {
            setTitle : function(newTitle) {
                $rootScope.title = newTitle;
                //$rootScope.$apply(); //force the refresh
            }
        };
    }]);  
})();